export enum SearchSections {
    All = "All",
    APIReference = "API Reference",
    Guides = "Guides"
}
